import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {useSearchParams } from 'router'
import  useActions from './use-actions'
import { useUser, useSites } from 'store'

export const ExitModeDemo = () => {
  const navigate = useNavigate()
  const {exitDemoMode} = useActions()

  useEffect(() => {
    exitDemoMode()
      .then(() => navigate('/auth/me'))
  }, [])

  return null
}

export const FakeOut = () => {
  const [user] = useUser()
  const [userId] = useState(user?.sf_contact_id || user?.user_id)
  const navigate = useNavigate()
  const {fakeout} = useActions()

  useEffect(() => {
    fakeout().then(() => {
      navigate(`/auth/me?redirect=/contacts/list/${userId}`)
    })
  }, [])

  return null
}

const Fake = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [, setSites] = useSites()
  const {fake} = useActions()
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    fake(searchParams.get('email')).then(() => {
      setSites(prev => ({...prev, focus: undefined, selected: [], accounts: []}))
      navigate('/auth/me')
    })
  }, [])

  return null
}

export default Fake
